import OadpRadio from './oadp-radio';
export default OadpRadio;
